export const USER_TYPE = {
  PART: "PART",
  PRO: "PRO",
};

export const SERVICE_TYPE = {
  TRIP: "TRIP",
  HOTE: "HOTE",
};
